/**
 * 路由封装
 */
// eslint-disable-next-line no-use-before-define
import React, {useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { KeepaliveRouterSwitch, KeepaliveRoute, addKeeperListener, useCacheDispatch } from 'src/components/react-keepalive-router/index.jsx';
import routerConfig from './menuRouter';
import { RouterConfigBase, RouterConfig } from './types';
import RouterWrap from './routerWrap';
import { connect } from 'react-redux';
import { ACTIVE_MENU } from 'src/store/common/menuTabs';
import bus from 'src/utils/eventBus';

type Props = {
    dispatch: React.Dispatch<any>;
}

const Routers: React.FC<Props> = (props) => {
    const cacheDispatch = useCacheDispatch();

    const Router = (v: RouterConfigBase) => {
        const Component = v.component;

        return <KeepaliveRoute cacheId={v.key} key={v.key || v.route} path={v.route} render={(restProps: any) => <RouterWrap {...{ restProps, Com: Component, route: v }} />}></KeepaliveRoute>;
    };
    const subRoute = (v: RouterConfig): any => v.subs && v.subs.map((subR: RouterConfig) => subR.subs ? subRoute(subR) : Router(subR));
    const CreateRouter = (v: RouterConfig) => v.component ? Router(v) : subRoute(v);
    const RouterList = (v: string) => routerConfig[v].map(CreateRouter);

    useEffect(() => {
        addKeeperListener((history:any, cacheKey:any) => {
            if (history) {
                const { dispatch } = props;

                dispatch({
                    type: ACTIVE_MENU,
                    value: cacheKey,
                });
            }
        });
        bus.on('closeTab', async (tabList) => {
            if (tabList.length) {
                cacheDispatch({ type: 'reset', payload: tabList});
            } else {
                cacheDispatch({ type: 'reset'});
            }
        });
        return () => {
            cacheDispatch({ type: 'destoryed'});
            bus.removeAllListeners('closeTab');
        };
    }, []);

    return (
        <KeepaliveRouterSwitch>
            {Object.keys(routerConfig).map((v: string) => RouterList(v))}
            <Route path='*' render={() => <Redirect to='/404' />} />
        </KeepaliveRouterSwitch>
    );
};

export default connect()(Routers);
